"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_hot_loader_1 = require("react-hot-loader");
const react_router_dom_1 = require("react-router-dom");
const Application_1 = __importDefault(require("./Application"));
const BlogIndex_1 = __importDefault(require("./blog/BlogIndex"));
const BlogRoutes_1 = __importDefault(require("./blog/BlogRoutes"));
const childRoutes = [
    {
        path: "/blog",
        element: react_1.default.createElement(BlogIndex_1.default, null),
    },
].concat(BlogRoutes_1.default);
const router = (0, react_router_dom_1.createBrowserRouter)([
    {
        path: "/",
        element: react_1.default.createElement(Application_1.default, null),
        children: childRoutes,
    },
]);
const Root = () => {
    return react_1.default.createElement(react_router_dom_1.RouterProvider, { router: router });
};
exports.default = (0, react_hot_loader_1.hot)(module)(Root);
